<template>
  <van-popup
    :show="show"
    @update:show="handleVisibleChange"
    position="bottom"
    :style="{ height: '65%', zIndex: 2001 }"
    :overlay-style="{ zIndex: 2000 }"
    closeable
    get-container="body"
  >
    <div class="form-wrapper">
      <div class="form-header">
        <h3 class="form-title">立即预约</h3>
        <p class="form-subtitle">填写信息，快速完成预约</p>
      </div>
      
      <van-form @submit="handleSubmit" class="appointment-form">
        <div class="form-section">
          <div class="section-title">基本信息</div>
          <van-field
            v-model="form.name"
            name="name"
            label="姓名"
            placeholder="请输入您的姓名"
            :rules="[{ required: true, message: '请输入姓名' }]"
            class="form-field"
            label-class="bold-label"
          />
          <van-field
            v-model="form.phone"
            name="phone"
            label="手机号"
            placeholder="请输入您的手机号"
            :rules="[
              { required: true, message: '请输入手机号' }, 
              { pattern: /^1[3-9]\d{9}$/, message: '请输入正确的手机号' }
            ]"
            class="form-field"
            label-class="bold-label"
          />
          
          <div class="payment-info">
            <span class="payment-label">需付款</span>
            <span class="payment-amount">¥{{ amount }}</span>
          </div>
        </div>
        
        <div class="form-submit">
          <van-button 
            round 
            block 
            type="primary" 
            native-type="submit"
            class="submit-button"
            :loading="loading"
            loading-text="支付中..."
          >
            提交并支付
          </van-button>
        </div>
      </van-form>
    </div>
  </van-popup>
</template>

<script>
import { Popup, Form, Field, Button } from 'vant'
import { showToast, showSuccessToast, showFailToast, showLoadingToast } from 'vant'
import request from '../utils/request'
import { safeWechatPay } from '../utils/wechat'  // 导入封装的支付方法

export default {
  name: 'AppointmentForm',
  components: {
    [Popup.name]: Popup,
    [Form.name]: Form,
    [Field.name]: Field,
    [Button.name]: Button
  },
  props: {
    show: {
      type: Boolean,
      default: false,
      required: true
    },
    amount: {
      type: Number,
      default: 99  //
    }
  },
  data() {
    return {
      form: {
        name: '',
        phone: ''
      },
      loading: false
    }
  },
  methods: {
    handleVisibleChange(newVisible) {
      console.log('弹窗状态变化:', newVisible)
      this.$emit('update:show', newVisible)
      if (!newVisible) {
        this.form = { name: '', phone: '' }
        this.loading = false
      }
    },
    
    async handleSubmit() {
      // 表单验证
      if (!this.form.name.trim()) {
        showToast('请输入姓名')
        return
      }
      
      if (!this.form.phone.trim() || !/^1[3-9]\d{9}$/.test(this.form.phone)) {
        showToast('请输入正确的手机号')
        return
      }

      this.loading = true
      
      try {
        const toast = showLoadingToast({
          message: '正在发起支付...',
          duration: 0,
          forbidClick: true
        })
        
        // 直接调用创建订单接口，授权逻辑在后端处理
        const orderResult = await this.createOrder()
        
        // 使用封装的微信支付方法
        await this.wechatPay(orderResult)
        
        toast.close()
        showSuccessToast('支付成功，预约已完成！稍后联系您提供服务')
        this.handleVisibleChange(false)
        
      } catch (error) {
        console.error('支付失败:', error)
        
        // 如果是授权相关错误，提示用户重试
        if (error.message.includes('授权') || error.message.includes('未登录')) {
          showFailToast('请重新点击预约按钮')
        } else {
          showFailToast(error.message || '支付失败，请重试')
        }
      } finally {
        this.loading = false
      }
    },

    // 创建订单
    async createOrder() {
      try {
        const response = await request.post('/order/create', {
          name: this.form.name,
          phone: this.form.phone
        })

        if (response?.code === 0) {
          return response?.data
        } else {
          throw new Error(response?.message || '创建订单失败')
        }
      } catch (error) {
        console.error('创建订单错误:', error)
        throw new Error('网络错误，请稍后重试')
      }
    },

    // 使用封装的微信支付方法
    async wechatPay(payParams) {
      try {
        console.log('开始调用微信支付:', payParams)
        await safeWechatPay(payParams)
        console.log('支付成功')
      } catch (error) {
        console.error('微信支付失败:', error)
        throw error
      }
    }
  }
}
</script>

<!-- 样式保持不变 -->
<style scoped>
.form-wrapper {
  padding: 0;
  height: 100%;
  overflow-y: auto;
  box-sizing: border-box;
  display: flex;
  flex-direction: column;
  background: #f8f8f8;
}

.form-header {
  background: white;
  padding: 20px 20px 12px;
  text-align: center;
  border-bottom: 1px solid #f0f0f0;
}

.form-title {
  margin: 0 0 6px 0;
  font-size: 20px;
  font-weight: bold;
  color: #333;
  position: relative;
}

.form-title::after {
  content: '';
  position: absolute;
  bottom: -6px;
  left: 50%;
  transform: translateX(-50%);
  width: 35px;
  height: 3px;
  background: linear-gradient(90deg, #ff3b30, #ff6b6b);
  border-radius: 2px;
}

.form-subtitle {
  margin: 8px 0 0 0;
  font-size: 13px;
  color: #999;
}

.appointment-form {
  flex: 1;
  display: flex;
  flex-direction: column;
  padding: 0 15px;
}

.form-section {
  background: white;
  border-radius: 10px;
  padding: 15px 12px;
  margin: 12px 0;
  box-shadow: 0 1px 4px rgba(0, 0, 0, 0.04);
}

.section-title {
  font-size: 15px;
  font-weight: 600;
  color: #333;
  margin-bottom: 15px;
  padding-left: 6px;
  border-left: 3px solid #ff3b30;
}

.form-field {
  margin-bottom: 15px;
  background-color: #fafafa;
  border-radius: 8px;
  padding: 6px 12px;
}

:deep(.bold-label) {
  font-weight: 600 !important;
  color: #333 !important;
  font-size: 14px;
}

.payment-info {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 12px 6px 0;
  border-top: 1px dashed #eee;
  margin-top: 8px;
}

.payment-label {
  font-size: 14px;
  color: #666;
  font-weight: 500;
}

.payment-amount {
  font-size: 16px;
  color: #333;
  font-weight: 600;
}

.form-submit {
  margin-top: 15px;
  padding: 15px 0 20px;
}

.submit-button {
  width: 100%;
  height: 48px;
  font-size: 16px;
  font-weight: 600;
  background: linear-gradient(135deg, #ff3b30, #ff6b6b) !important;
  border: none !important;
  color: white !important;
  box-shadow: 0 4px 12px rgba(255, 59, 48, 0.3);
  transition: all 0.3s ease;
}

.submit-button:active {
  transform: translateY(1px);
  box-shadow: 0 2px 6px rgba(255, 59, 48, 0.4);
}
</style>